  // import { createContext, useContext, useEffect, useState } from "react";
  // import { useNavigate } from "react-router-dom";

  // const ChatContext = createContext();

  // const ChatProvider = ({ children }) => {
  //   const [user, setUser] = useState(null);
  //   const [chats, setChats] = useState([]);
  //   const [notification, setNotification] = useState([]);
  //   const [selectedChat, setSelectedChat] = useState(null);

  //   const navigate = useNavigate();

  //   useEffect(() => {
  //     const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  //     setUser(userInfo);

  //     if (!userInfo) {
  //       navigate("/");
  //     }
  //   }, [navigate]);

  //   return (
  //     <ChatContext.Provider
  //       value={{
  //         user,
  //         setUser,
  //         selectedChat,
  //         setSelectedChat,
  //         chats,
  //         setChats,
  //         notification,
  //         setNotification,
  //       }}
  //     >
  //       {children}
  //     </ChatContext.Provider>
  //   );
  // };

  // export const ChatState = () => {
  //   return useContext(ChatContext);
  // };

  // export default ChatProvider;
import { createContext, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const ChatContext = createContext();

const ChatProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [chats, setChats] = useState([]);
  const [notification, setNotification] = useState([]);
  const [selectedChat, setSelectedChat] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    setUser(userInfo);

    if (!userInfo) {
      navigate("/");
    }
  }, [navigate]);

  const fetchChats = async () => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${user.token}`,
        },
      };

      const { data } = await axios.get(
        `https://dochats.onrender.com/api/chat`,
        config
      );
      setChats(data);
      console.log("Chats fetched:", data); // Add console log
    } catch (error) {
      console.error("Failed to fetch chats", error);
    }
  };

  const removeUserFromChat = async (chatId, userId) => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${user.token}`,
        },
      };

      await axios.put(
        `https://dochats.onrender.com/api/chat/groupremove`,
        { chatId, userId },
        config
      );
      fetchChats(); // Fetch the updated chat list
      console.log("User removed from chat:", userId); // Add console log
    } catch (error) {
      console.error("Failed to remove the user from chat", error);
    }
  };

  useEffect(() => {
    if (user) {
      fetchChats();
    }
  }, []);

  return (
    <ChatContext.Provider
      value={{
        user,
        setUser,
        selectedChat,
        setSelectedChat,
        chats,
        setChats,
        notification,
        setNotification,
        removeUserFromChat, // Ensure deleteUser is included here
      }}
    >
      {children}
    </ChatContext.Provider>
  );
};

export const ChatState = () => {
  return useContext(ChatContext);
};

export default ChatProvider;
